// 党费缴纳
export default [
    {
      path: "payMoney",
      name: "payMoney",
      component: () => import("@/views/payMoney/index.vue"),
    },
  ];